import script from "./FrontDoorSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FrontDoorSection.vue?vue&type=script&setup=true&lang=js"

import "./FrontDoorSection.vue?vue&type=style&index=0&id=5c7fe9d3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c7fe9d3"]])

export default __exports__